import { getUserLanguagePreferenceForTables } from '../../../../common/users/utils/userPropertyUtils';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import getUserLocale from 'get-user-locale';
import hyperFormulaInstance, { getHyperformulaDateFormat } from './manager/hyperFormulaInstance';
import { getCurrentUser } from '../../../user/currentUserSelector';

const useTableConfigInit = () => {
    const currentUser = useSelector(getCurrentUser);
    const userLanguage = getUserLanguagePreferenceForTables(currentUser);

    useEffect(() => {
        try {
            const dateFormats = getHyperformulaDateFormat(userLanguage || getUserLocale() || 'en-US');
            hyperFormulaInstance.updateConfig({ dateFormats });
        } catch (error) {
            // HyperFormula throws error when updating user language, but it doesn't impact the behaviour.
            // Do nothing here.
        }
    }, [userLanguage]);
};

export default useTableConfigInit;
